<template>
  <div class="editLogList">
    <el-table
      ref="multipleTables"
      :data="tableData"
      size="mini"
      style="width: 100%; margin: 20px"
      @row-click="rowClicked"
      border
      v-if="type === 'second'"
    >
      <!-- <el-table-column type="selection" width="50"></el-table-column> -->
      <el-table-column type="index" width="50" label="序号"></el-table-column>
      <el-table-column
        v-for="(item, index) in tableColumnDatas"
        :key="index"
        :prop="item.class"
        :label="item.labelName"
        show-overflow-tooltip
        align="center"
        header-align="center"
      >
      </el-table-column>
    </el-table>
    <el-table
      ref="multipleTables"
      :data="tableStatusData"
      size="mini"
      style="width: 100%; margin: 20px"
      @row-click="rowClicked"
      border
      v-else
    >
      <!-- <el-table-column type="selection" width="50"></el-table-column> -->
      <el-table-column type="index" width="50" label="序号"></el-table-column>
      <el-table-column
        v-for="(item, index) in tableStatusDatas"
        :key="index"
        :prop="item.class"
        :label="item.labelName"
        show-overflow-tooltip
        align="center"
        header-align="center"
      >
      </el-table-column>
      <!-- <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="plain"
            v-if="scope.row.isEdit"
            @click="saveChange(scope.row)"
          >保存</el-button>
          <el-button type="plain" v-else @click="editSingleTable(scope.row)">编辑</el-button>
        </template>
      </el-table-column> -->
    </el-table>
  </div>
</template>

<script>
import { numFilter } from "@/utils/filters";
import {
  getEditSupplierLogList, //获取供应商一级类别列表接口
  getStatusSupplierLogList, //查询子类别列表接口
} from "@/services/supplierMagServices";

export default {
  name: "editLogList",
  props: {
    supplierId: {
      type: Number,
      default: 0,
    },
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      pageSize: 20,
      pageIndex: 1,
      tableData: [],
      tableStatusData: [],
      tableColumnDatas: [
        { class: "operateTime", labelName: "修改时间", sortEnable: false },
        {
          class: "operateUserAccount",
          labelName: "修改人账号",
          sortEnable: false,
        },
        {
          class: "operateUserName",
          labelName: "修改人姓名",
          sortEnable: false,
        },
        { class: "operateUserJobName", labelName: "角色", sortEnable: false },
      ],
      tableStatusDatas: [
        { class: "operateTime", labelName: "修改时间", sortEnable: false },
        {
          class: "operateUserAccount",
          labelName: "修改人账号",
          sortEnable: false,
        },
        {
          class: "operateUserName",
          labelName: "修改人姓名",
          sortEnable: false,
        },
        { class: "statusDisplayName", labelName: "操作", sortEnable: false },
        { class: "stopReason", labelName: "说明", sortEnable: false },
      ],
    };
  },
  // created() {
  //   this.pageIndex = 1;
  //   this.initList(); //获取列表  gaa 20200826
  // },

  watch: {
    type(newVal) {
      if (newVal) {
        this.pageIndex = 1;
        this.initList(); //获取列表  gaa 20200826
      }
    },
  },
  methods: {
    initList() {
      let param = {
        supplierId: this.supplierId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      // debugger
      if (this.type !== "second") {
        getStatusSupplierLogList(param, true)
          .then((res) => {
            if (res.code == 10000000) {
              this.tableStatusData = res.data;
              this.totalCount = res.total;
            } else {
              if (res.code > 20000000) {
                this.$alert(res.msg, "提示", {
                  confirmButtonText: "确定",
                });
              } else {
                this.$alert("系统异常", "提示", {
                  confirmButtonText: "确定",
                });
              }
            }
          })
          .catch((error) => {
            // this.$message.error(error.msg);
          });
      } else {
        getEditSupplierLogList(param, true)
          .then((res) => {
            if (res.code == 10000000) {
              this.tableData = res.data;
              this.totalCount = res.total;
            } else {
              if (res.code > 20000000) {
                this.$alert(res.msg, "提示", {
                  confirmButtonText: "确定",
                });
              } else {
                this.$alert("系统异常", "提示", {
                  confirmButtonText: "确定",
                });
              }
            }
          })
          .catch((error) => {
            // this.$message.error(error.msg);
          });
      }
    }, //
    /* 分页改变事件 */
    handleCurrentChange(page) {
      console.log(page);
      this.pageIndex = page;
      this.initList();
    },
    /* 分页显示数量改变事件 */
    handleSizeChange(rows) {
      this.pageSize = rows;
      this.pageIndex = 1;
      this.initList();
    },
    // 点击选中行
    rowClicked(row, event, column) {
      this.$refs.multipleTables.toggleRowSelection(row);
    },

    //导入工程量清单子目
    importSubEngineer() {
      this.isImportengineerDialog = true;
      this.showUploadDialog = true;
    },

    moreScreen() {
      this.showAdvanceFilter = !this.showAdvanceFilter;
      if (this.showAdvanceFilter) {
        this.tableHeight = this.$refs.main.$el.offsetHeight - 144 - 10;
      } else {
        this.tableHeight = this.$refs.main.$el.offsetHeight + 144 - 10;
      }
    },

    //设置小计
    getSummaries(param) {
      let _this = this;
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 4) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (
          !values.every((value) => isNaN(value)) &&
          (column.property == "quantity" || column.property == "totalPrice")
        ) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          // sums[index] += '';
          sums[index] = numFilter(sums[index]);
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
  },
};
</script>
<style scoped >
::v-deep .el-tabs__item {
  height: 56px;
  line-height: 56px;
  width: 160px;
  padding: 0 !important;
  font-size: 18px;
  color: #666666 !important;
}
::v-deep .el-tabs__header {
  padding-right: 0;
}
</style>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.editLogList {
  .operatePanel {
    text-align: right;
  }
}
.el-container {
  padding-top: 0;
  .el-header {
    padding: 0;
    form {
      padding-right: 20px;
    }
  }
}

::v-deep .el-tabs__header {
  padding-right: 0 !important;
  background: #d5e7ed !important;
}
.el-select {
  width: 100%;
}
.hide {
  display: none;
}

::v-deep .overTimeMark {
  background-color: #e9f4fa;
  .el-tooltip {
    color: #333333;
  }
}

::v-deep .el-form-item__content {
  width: 60%;
}
::v-deep .el-form-item {
  width: 100%;
}
::v-deep .el-date-editor {
  width: 100% !important;
}
</style>
